module.exports = __webpack_public_path__ + "static/media/promo-code.a6a90aa5.svg";